import io from "socket.io-client";
import React from "react";
let SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
let SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;
export const socket = io.connect(SOCKET_URL, {
  path: SOCKET_PATH,
  //reconnection: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999,
  transports: ["websocket"],
  // forceNew: true,
  pingInterval: 1000 * 60 * 5,
  pingTimeout: 1000 * 60 * 3,
  //     pingInterval: 24 * 60 * 60 * 1000,
  // pingTimeout: 3 * 24 * 60 * 60 * 1000
  // upgrade: false,
  // autoConnect: false,
  query: `auth_token=website-chatbot`,
});
export const SocketContext = React.createContext();
